import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    component: () => import("./pages/KioskPage.vue"),
    name: "kiosk",
    path: "/",
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
